import { useLayoutEffect, useRef } from 'react';
import styled from 'styled-components';
import { Loader } from '@elfsight/widget-ui';
import { classnamePrefix } from '../../../../constants';

const SCROLL_EPS = 1;

export const PlaylistVideos = ({ children, loadNext, hasNext, loading }) => {
  const videos = useRef();

  const checkScroll = () => {
    const {
      current: { scrollHeight, scrollTop, clientHeight }
    } = videos;

    const deltaScroll = Math.floor(scrollHeight - scrollTop);
    const bottom =
      deltaScroll >= clientHeight - SCROLL_EPS &&
      deltaScroll <= clientHeight + SCROLL_EPS;

    if (bottom && hasNext && !loading && children.length) {
      loadNext();
    }
  };

  useLayoutEffect(() => {
    requestAnimationFrame(() => {
      if (videos?.current) {
        checkScroll();
      }
    });
  });

  return (
    <Component
      onScroll={() => {
        if (!loading) checkScroll();
      }}
      ref={videos}
    >
      {children}

      {loading && <StyledLoader size={40} color="#fff" />}
    </Component>
  );
};

export const Component = styled.div.attrs({
  className: `${classnamePrefix}-playlist-videos-component`
})`
  flex-shrink: 0;
  display: flex;
  overflow-x: hidden;
  overflow-y: auto;
  flex-direction: column;
  background-color: #2c2c2c;
  padding-right: 4px;
  height: 100%;
  width: 100%;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: #949393;
  }

  &
    .${classnamePrefix}-video-card-number,
    &
    .${classnamePrefix}-video-card-name {
    color: #fff;
  }
`;

const StyledLoader = styled(Loader).attrs({
  className: `${classnamePrefix}-spinner-component`
})`
  margin: 20px auto;
  flex-shrink: 0;
`;
